import { Project } from 'common/contracts';

import { ReportApiResponse, ReportTableRow } from '../types';

export const getProjectNames = (publishers: string[], projectsDetails?: Project[]): string => {
    if (!projectsDetails) return '';

    if (publishers.length > 1 && publishers.length === projectsDetails.length) {
        return 'All';
    }

    return publishers
        .map((publisherId: string) =>
            projectsDetails?.find((project: Project) => project.publisherId === publisherId)?.publisherName
        )
        .filter(Boolean)
        .join(', ');
};

export const createReportTableRow = (report: ReportApiResponse, projectNames: string): ReportTableRow => {
    return {
        id: report.reportId,
        reportId: report.reportId,
        dateCreated: report.createdAt || report.timestamp || report.createdDate || new Date().toISOString(),
        project: projectNames,
        projectNames: projectNames,
        publishers: report.publishers,
        startDate: report.interval.startDate,
        endDate: report.interval.endDate,
        status: report.status,
        createdBy: report.createdBy
    };
};

export const transformReportsToTableData = (
    reports: ReportApiResponse[] | undefined,
    projectsDetails: Project[] | undefined,
    allowedPublishers: string[]
): ReportTableRow[] => {
    if (!reports) return [];

    return reports
        .filter((report: ReportApiResponse) =>
            report.publishers.every((publisherId: string) => allowedPublishers.includes(publisherId))
        )
        .map((report: ReportApiResponse) => {
            const projectNames = getProjectNames(report.publishers, projectsDetails);
            return createReportTableRow(report, projectNames);
        });
};

